import { render } from "./FaqCategory.vue?vue&type=template&id=54155aee&scoped=true"
import script from "./FaqCategory.vue?vue&type=script&lang=js"
export * from "./FaqCategory.vue?vue&type=script&lang=js"

import "./FaqCategory.vue?vue&type=style&index=0&id=54155aee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54155aee"]])

export default __exports__